import Skeleton from "react-loading-skeleton";
import { TableBody, TableCell, TableRow } from "@/components/catalyst/Table";
import { AppStatisticsSkeleton } from "./components/AppStatistics";
import { ReferralLinksLayout } from "./ReferralLinksLayout";

export function ReferralLinksSkeleton() {
	return (
		<>
			<div className="mb-8">
				<div className="mb-4 flex items-center justify-between">
					<div>
						<h3 className="text-lg font-semibold text-base-content">
							Performance Overview
						</h3>
						<p className="mt-1 text-sm text-base-content/60">
							See how your referral program is performing
						</p>
					</div>
					<Skeleton width={192} height={38} borderRadius={8} />
				</div>
				<AppStatisticsSkeleton />
			</div>
			<ReferralLinksLayout
				onCreateClick={() => {}}
				onNext={() => {}}
				onPrevious={() => {}}
				hasPrevious={false}
				hasNext={false}
			>
				<TableBody>
					{Array.from({ length: 5 }).map((_, i) => (
						<TableRow key={i}>
							<TableCell>
								<Skeleton width={120} />
							</TableCell>
							<TableCell>
								<div className="flex items-center gap-2">
									<Skeleton width={80} />
									<Skeleton width={16} height={16} />
								</div>
							</TableCell>
							<TableCell>
								<Skeleton width={60} />
							</TableCell>
							<TableCell>
								<Skeleton width={40} />
							</TableCell>
							<TableCell>
								<Skeleton width={60} borderRadius={9999} />
							</TableCell>
							<TableCell>
								<Skeleton width={100} />
							</TableCell>
							<TableCell>
								<div className="flex items-center justify-end">
									<Skeleton width={20} height={20} circle />
								</div>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</ReferralLinksLayout>
		</>
	);
}
